import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../../../generic-components/Heading';
import { convertValueToUSD } from '../../../../../../helpers/currency.helper';
import { MAX_INVOICE_AMOUNT } from '../../../consts/consts';

interface IProps {
    title: string;
    subtotalAmount?: number;
    totalAmount?: number;
}

export const TotalAmount = ({
  title, totalAmount, subtotalAmount,
}: IProps) => {
  const { t } = useTranslation();

  const isInvoiceAmountValid = useMemo(() => !(subtotalAmount && (subtotalAmount > MAX_INVOICE_AMOUNT)), [subtotalAmount]);

  return (
    <div className='flex items-center justify-between grow py-[18px] px-[16px] relative'>
      <Heading title={title} className='font-metricRSemibold text-[16px] text-bw08' />
      <Heading id='totalValue' title={convertValueToUSD(totalAmount || 0, 2)} className={`${isInvoiceAmountValid ? 'text-bw08' : 'text-red02'} font-metricRSemibold text-[16px]`} />
      {!isInvoiceAmountValid && <p className='font-metricR text-[12px] text-red02 absolute bottom-0 right-0 translate-y-[110%] translate-x-[-16px]'>{t('INVOICE_MAX_AMOUNT')}</p>}
    </div>
  );
};
